import Immutable, { Map } from 'immutable';
import moment from 'moment';
import * as QuickbetActions from '../../actions/coupon/quickbet';
import * as MakeBetAction from '../../actions/makeBet';
import * as CancelBigStakeAction from '../../actions/BigStakeRequest';
import * as BetStatus from '../../constants/BetStatus';
import * as BettingState from '../../constants/BettingState';
import * as BetCreateErrorStatus from '../../constants/BetCreateErrorStatus';
import { GET_QUICKBET_STATUS, LIVE_UPDATE_BETSLIPS } from '../../sagas/actions';
var initialState = new Map({
    status: BetStatus.INIT,
    resolution: undefined,
    stakeTime: undefined,
    betCreateError: undefined,
    freebetErrors: undefined,
    bet: new Map(),
    bigStakeCancelError: undefined,
    loading: false,
    limit: undefined
});
export default function quickBetReducer(quickBet, action) {
    switch (action.type) {
        case QuickbetActions.OPEN_QUICKBET_MODAL:
            return quickBet.update('loading', function () { return false; });
        case QuickbetActions.ADD_QUICKBET_RATE:
            return addQuickbet(quickBet, action.data);
        case QuickbetActions.CLOSE_QUICKBET_MODAL:
            return initialState;
        case MakeBetAction.MAKE_QUICKBET:
            quickBet = quickBet.update('betCreateError', function () { return undefined; });
            return quickBet.update('loading', function () { return true; });
        case MakeBetAction.SUCCESS_MAKE_QUICKBET:
            quickBet = quickBet.update('loading', function () { return false; });
            if (action.data && action.data.Error) {
                quickBet = quickBet.update('status', function () { return BetStatus.REJECTED; });
                quickBet = quickBet.update('betCreateError', function () { return action.data.Error; });
                quickBet = quickBet.update('limit', function () { return action.data.Limit; });
                return quickBet;
            }
            else if (action.data.FreebetErrors) {
                quickBet = quickBet.update('status', function () { return BetStatus.REJECTED; });
                quickBet = quickBet.update('freebetErrors', function () { return action.data.FreebetErrors; });
                quickBet = quickBet.update('limit', function () { return action.data.Limit; });
            }
            if (action.data.State === BetStatus.CONFIRMED) {
                quickBet.update('status', function () { return BetStatus.CONFIRMED; });
                return quickBet = betCreated(quickBet, action.data);
            }
            return betCreated(quickBet, action.data);
        case MakeBetAction.SUCCESS_MAKE_MULTI_SINGLE_BET:
            return betCreated(quickBet, action.data);
        case MakeBetAction.FAILURE_MAKE_MULTI_SINGLE_BET:
            return quickBet.update('status', function () { return BetStatus.REJECTED; });
        case QuickbetActions.ACCEPT_QUICKBET_FACTOR_CHANGE:
            quickBet = quickBet.update('betCreateError', function () { return undefined; });
            return acceptFactorChange(quickBet, action.data);
        // case LIVE_UPDATE.SUCCESS:
        // case LIVE_MATCH_UPDATE.SUCCESS:
        //     if (quickBet.get('status') !== BetStatus.STAKE_REQUEST) {
        //         return update(quickBet, action.data);
        //     } else {
        //         return quickBet;
        //     }
        case LIVE_UPDATE_BETSLIPS.SUCCESS:
            quickBet = quickBet.update('bet', function (bet) { return updateRate(bet, action.data); });
            return quickBet;
        case GET_QUICKBET_STATUS.SUCCESS:
            if (action.data.State === BetStatus.CONFIRMED) {
                return quickBet.update('status', function () { return BetStatus.CONFIRMED; });
            }
            return changeBetStatus(quickBet, action.data);
        case MakeBetAction.FAILURE_MAKE_BET:
        case GET_QUICKBET_STATUS.FAILURE:
            quickBet = quickBet.update('loading', function () { return false; });
            return changeBetToRejected(quickBet);
        case CancelBigStakeAction.QUICKBET_SUCCESS_BIG_STAKE_REQUEST_CANCEL:
            var bigStakeRequestCancel = action.data;
            var error = bigStakeRequestCancel.Error;
            if (error !== undefined) {
                if (error === -1) {
                    quickBet = quickBet.update('bigStakeCancelError', function () { return 1; });
                }
                else if (error === -100) {
                    return quickBet;
                }
            }
            return quickBet.update('status', function () { return BetStatus.REJECTED; });
        case CancelBigStakeAction.QUICKBET_FAILURE_BIG_STAKE_REQUEST_CANCEL:
            quickBet = quickBet.update('bigStakeCancelError', function () { return 1; });
            return quickBet.update('status', function () { return BetStatus.REJECTED; });
        default:
            return quickBet;
    }
}
function addQuickbet(quickBet, addRate) {
    var match = addRate.match;
    var outcome = addRate.outcome;
    var rate = addRate.rate;
    var rateId = rate.get('id');
    if (!quickBet.has(rateId)) {
        var value_1 = Immutable.fromJS({
            rate: rate,
            outcome: {
                name: outcome.get('name')
            },
            match: {
                name: match.get('name'),
                timeAndZone: match.get('timeAndZone'),
                notice: match.get('notice')
            }
        });
        quickBet = quickBet.updateIn(['bet', rateId], function () { return value_1; });
    }
    return quickBet;
}
function updateRate(betSlips, data) {
    try {
        betSlips = betSlips.map(function (bs, rateId) {
            var v = ((data || []).find(function (_a) {
                var id = _a.id;
                return id === rateId;
            }) || {}).v;
            if (v) {
                var factorChanged_1 = false;
                bs = bs.update('rate', function (r) {
                    if (r.get('value') !== v) {
                        r = r.update('actualValue', function () { return v; });
                        r = r.update('isBlocked', function () { return true; });
                        factorChanged_1 = true;
                    }
                    else {
                        factorChanged_1 = false;
                    }
                    return r;
                });
                bs = bs.update('factorChanged', function () { return factorChanged_1; });
            }
            else {
                bs = bs.update('rate', function (r) {
                    r = r.update('isBlocked', function () { return true; });
                    r = r.update('isBlockedByOutcome', function () { return true; });
                    return r;
                });
            }
            return bs;
        });
    }
    catch (error) {
        console.log('Error in quickBetReducer:updateRate');
    }
    return betSlips;
}
function betCreated(quickBet, createdBet) {
    if (createdBet.Error) {
        var betErrorStatus = BetCreateErrorStatus.INTERNAL_ERROR;
        switch (createdBet.Error) {
            case -3:
                betErrorStatus = BetCreateErrorStatus.FACTORS_CHANGED;
                var factors = createdBet.Factors;
                if (factors) {
                    var rateChange = getRateChange(factors);
                    var rateId = rateChange.factorId;
                    if (rateChange) {
                        if (rateChange.unavailable) {
                            quickBet = quickBet.setIn(['bet', rateId, 'unavailable'], true);
                        }
                        if (rateChange.factorChanged) {
                            quickBet = quickBet.setIn(['bet', rateId, 'factorChanged'], true);
                            quickBet = quickBet.setIn(['bet', rateId, 'rate', 'actualValue'], rateChange.value);
                        }
                    }
                }
                break;
            case -4:
                betErrorStatus = BetCreateErrorStatus.INSUFFICIENT_FUNDS;
                break;
            case -7:
            case -15:
                betErrorStatus = BetCreateErrorStatus.ACCOUNT_LOCKED;
                break;
            case -6:
                betErrorStatus = BetCreateErrorStatus.MIN_STAKE_AMOUNT;
                break;
            case -1:
            case -2:
            case -13:
                betErrorStatus = BetCreateErrorStatus.INCORRECT_STAKE;
                break;
            case -5:
            case -11:
                betErrorStatus = BetCreateErrorStatus.INCORRECT_VIRTUAL_STAKE;
                break;
            case -12:
                betErrorStatus = BetCreateErrorStatus.FREEBET_BIG_STAKE;
                break;
            case -9:
            case -10:
                betErrorStatus = BetCreateErrorStatus.INCORRECT_FREEBET_STAKE;
                break;
            case -14:
                betErrorStatus = BetCreateErrorStatus.EXISTING_ACTIVE_STAKE;
                break;
            case -16:
                betErrorStatus = BetCreateErrorStatus.NO_BIG_STAKE_PERMISSION;
                break;
            case -18:
                localStorage.removeItem('couponAmountValue');
                betErrorStatus = BetCreateErrorStatus.ALTERNATIVE_STAKE;
                quickBet = quickBet.set('alternativeStake', createdBet.AlternativeStake);
                break;
            case -19:
                localStorage.removeItem('couponAmountValue');
                betErrorStatus = BetCreateErrorStatus.NOT_POSSIBLE_STAKE;
                break;
            case -10000:
                betErrorStatus = BetCreateErrorStatus.INTERNAL_ERROR;
                break;
            default:
                betErrorStatus = createdBet.Error;
        }
        quickBet = quickBet.set('status', BetStatus.REJECTED);
        return quickBet.set('betCreateError', betErrorStatus);
    }
    else {
        var status_1 = createdBet.State;
        switch (status_1) {
            case BetStatus.CONFIRMED:
                return quickBet.update('status', function () { return status_1; });
            case BetStatus.IN_DELAY:
            case BetStatus.STAKE_REQUEST:
            case BetStatus.CONFIRM_AWAIT:
                var stakeTime = moment.tz(createdBet.StakeTime, 'Asia/Bishkek').clone().tz('UTC');
                quickBet = quickBet.set('status', status_1);
                quickBet = quickBet.set('stakeId', createdBet.BetId);
                quickBet = quickBet.set('delay', createdBet.Delay);
                quickBet = quickBet.set('stakeTime', stakeTime);
                return quickBet;
            default:
                return quickBet.update('status', function () { return BetStatus.INIT; });
        }
    }
}
function changeBetStatus(quickBet, betStatus) {
    if (betStatus.error) {
        if (betStatus.error === -100) {
            return quickBet;
        }
        changeBetToRejected(quickBet);
    }
    var state = betStatus.State;
    var factors = betStatus.Factors;
    var resolution = betStatus.Resolution;
    var stakeTime = moment.tz(betStatus.StakeTime, 'Asia/Bishkek').clone().tz('UTC');
    quickBet = quickBet.update('status', function () { return state; });
    quickBet = quickBet.update('resolution', function () { return resolution; });
    quickBet = quickBet.update('stakeTime', function () { return stakeTime; });
    if (factors) {
        var rateChange = getRateChange(factors);
        if (rateChange) {
            var rateId = rateChange.factorId;
            if (rateChange.unavailable) {
                quickBet = quickBet.setIn(['bet', rateId, 'unavailable'], true);
            }
            if (rateChange.factorChanged) {
                quickBet = quickBet.setIn(['bet', rateId, 'factorChanged'], true);
                if (rateChange.value > 0) {
                    quickBet = quickBet.setIn(['bet', rateId, 'rate', 'actualValue'], rateChange.value);
                }
            }
        }
    }
    return quickBet;
}
function getRateChange(factors) {
    var rateChange;
    for (var i = 0; i < factors.length; i++) {
        var factorId = factors[i].FactorId;
        var factorInitialValue = factors[i].InitialValue;
        var factorNewValue = factors[i].Value;
        var bettingState = factors[i].BettingState;
        switch (bettingState) {
            case BettingState.CORRECT:
                if (factorInitialValue !== factorNewValue) {
                    rateChange = {
                        factorId: factorId,
                        value: factorNewValue,
                        factorChanged: true
                    };
                }
                break;
            case BettingState.FACTOR_CHANGED:
                rateChange = {
                    factorId: factorId,
                    value: factorNewValue,
                    factorChanged: true
                };
                break;
            case BettingState.FACTOR_CLOSED:
            case BettingState.OUTCOME_CLOSED:
            case BettingState.EVENT_CLOSED:
                rateChange = {
                    factorId: factorId,
                    unavailable: true
                };
        }
    }
    return rateChange;
}
function acceptFactorChange(quickBet) {
    var betMap = quickBet.get('bet');
    var bet = betMap.get(betMap.keySeq().first());
    var rate = bet.get('rate');
    var rateId = rate.get('id');
    var actualValue = rate.get('actualValue');
    quickBet = quickBet.setIn(['bet', rateId, 'rate', 'value'], actualValue);
    quickBet = quickBet.deleteIn(['bet', rateId, 'rate', 'actualValue']);
    quickBet = quickBet.setIn(['bet', rateId, 'factorChanged'], false);
    return quickBet;
}
function changeBetToRejected(quickBet) {
    quickBet = quickBet.set('status', BetStatus.REJECTED);
    return quickBet.set('betCreateError', BetCreateErrorStatus.INTERNAL_ERROR);
}



// WEBPACK FOOTER //
// ./src/reducers/coupon/quickBetReducer.js